export class SearchParams {
    isLinkExpired: boolean = null;
    requestStatus = '';
    resultFileStatus = '';
    skip = 0;
    take = 500;
    query = '';
}
